/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AutoPaymentDetails } from '../models/AutoPaymentDetails';
import { request as __request } from '../core/request';

export class AutoPaysVService {

    /**
     * @param districtId
     * @returns AutoPaymentDetails Created
     * @throws ApiError
     */
    public static async autoPaysVCreateBatch(
        districtId: string,
    ): Promise<AutoPaymentDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/auto-payments/batch`,
            query: {
                'districtId': districtId,
            },
        });
        return result.body;
    }

    /**
     * @param autopayId
     * @returns any Accepted
     * @throws ApiError
     */
    public static async autoPaysVPostAutoPay(
        autopayId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/auto-payments/${autopayId}/run`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param autoPayId
     * @returns any Accepted
     * @throws ApiError
     */
    public static async autoPaysVRerunFailedPayments(
        autoPayId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/auto-payments/${autoPayId}/rerun`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}